import { BaseModel } from "@blue-chip/core";

export default class View extends BaseModel {
  static plural = "views";
}
